<template>
  <div class="page-menu" :class="{dark: dark}">
    <router-link
      :to="{
        name: 'search',
        query: { kategoria: category.slug }
      }"
      v-for="category in categories"
      :key="category.name"
      class="tile">
    <div class="close-nav" @click="closePageNav" v-if="virtualData.categories[category.slug]">
        <h2>
          <span class="text-l">
            {{virtualData.categories[category.slug].header}}
          </span>
        </h2>
        <div @mouseenter="mouseEnter(category.name, category.image)"
             @mouseleave="mouseLeave(category.name)"
             :class="{
               'image-wrapper': true,
               [category.name]: true
              }">
          <img class="image-animation"
               src="@/assets/images/pixel.gif"
               :alt="category.name" />
          <img class="image-static"
               :src="category.imageStatic"
               :alt="category.name" />
          <img class="image-background" src="@/assets/images/bg/shadow.png" alt="" />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'virtualMenu',
  props: ['dark'],
  data () {
    return {
      loadedImages: []
    }
  },
  computed: {
    ...mapGetters([
      'categories',
      'translation',
      'activeCategory',
      'virtualData',
      'gifsLoaded'
    ])
  },
  methods: {
    ...mapActions([
      'closePageNav',
      'setGifsLoaded'
    ]),
    mouseEnter (categoryName, categoryImg) {
      const $link = event.target
      if (this.loadedImages.length && this.loadedImages.includes(categoryImg)) {
        let $gif = event.target.querySelector('.image-animation')
        if (!$gif) { return false }
        setTimeout(() => {
          $gif.src = categoryImg
          $link.classList.add('image-wrapper-active')
        }, 100)
      }
    },
    mouseLeave (categoryName) {
      const $link = event.target
      $link.classList.remove('image-wrapper-active')
    },
    loadImages () {
      let images = this.categories.map(cat => cat.image)
      images.forEach(imgUrl => {
        if (this.gifsLoaded) {
          let img = new Image()
          img.onload = () => {
            this.loadedImages.push(imgUrl)
          }
          img.src = imgUrl
        } else {
          this.loadedImages.push(imgUrl)
        }
      })
      this.setGifsLoaded()
    }
  },
  mounted () {
    this.loadImages()
  },
  watch: {
    categories (oldVal, newVal) {
      this.loadImages()
    }
  }
}
</script>

<style scoped lang="scss">

.page-menu {
  // background: $virtual-menu-bg;
  // width: 100vw;
  // min-height: 80vh;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  height: 100vh;
  padding: 120px 0 80px;
  .close-nav {
    height: 100%;
  }
}

.tile {
  cursor: pointer;
  display: block;
  flex-basis: 33.33%;
  height: 33.33%;
  // width: 26%;
  position: relative;
  text-decoration: none;
  color: $text-light;
  padding: 0;
  h2 {
    top: 20px;
    left: 20px;
    margin: 0;
    position: absolute;
    text-align: left;
    text-transform: uppercase;
    overflow: hidden;
    padding: 0 0 $gap-md 0;
    transition: $transition;
    z-index: 10;
    &:before {
      content: '';
      display: block;
      width: 30px;
      height: 3px;
      background-color: $bg-accent;
      position: absolute;
      bottom: 0;
      // left: 100%;
      left: 0;
      transition: $transition;
    }
    span {
      display: block;
      // transform: translateX(100%);
      // transition: $transition;
    }
  }
  &:after,
  &:before {
    content: '';
    width: 2px;
    height: 100px;
    display: none;
    background-color: rgba(#ffffff, 0.04);
    position: absolute;
    bottom: -2px;
    right: -2px;
    transform: translate(50%, 50%);
    z-index: 9;
  }
  &:after {
    width: 100px;
    height: 2px;
  }
  &:nth-child(1),
  &:nth-child(2),
  &:nth-child(4),
  &:nth-child(5) {
    &:after,
    &:before {
      content: '';
      display: block;
    }
  }
}
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
.image-wrapper {
  position: relative;
  height: 76%;
  margin-top: 8vh;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: 3;
    .dark & {
      background: $bg-dark;
    }
  }
  &.typewriters,
  &.planes {
    img {
      max-height: 80%;
    }
    .image-background {
      max-height: 100%;
    }
  }
  &.typewriters {
    img {
      margin-top: 14px;
    }
    .image-background {
      margin-top: 0;
    }
  }
  &.others {
    img {
      margin-top: -5px;
    }
    .image-background {
      margin-top: 0;
    }
  }

} // END .image-wrapper;
a {

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    max-width: 100%;
    max-height: 100%;
    transition: $transition;
    z-index: -1;
  }
  .image-animation {
    opacity: 0;
    transition: opacity 0.3s;
  }
  .image-static {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s;
    z-index: 3;
  }
  .image-background {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    transition: transform 0.2s ease-in-out;;
  }

  .image-wrapper-active {
    .image-animation {
      opacity: 1;
    }
    .image-static {
      opacity: 0;
      z-index: 1;
    }
  } // END .image-wrapper-active;

  &:hover {
    .image-wrapper {
      &:before {
        background-color: transparent;
        opacity: 0;
      }
    }
    .image-animation {
      display: inline-block;
    }
    img {
      transform: translate(-50%, -50%) scale(1.1);
      z-index: 4;
    }
    .image-background {
      transform: translate(-50%, -50%) scale(1);
    }
    // .image-static {
    //   opacity: 0;
    //   z-index: 1;
    // }
    h2 {
      &:before {
        // left: 0;
        background-color: $color-inverted;
        width: 100%;
      }
      // span {
      //   transform: translateX(0);
      // }
    }
  }
}
</style>
